import axios from "../../config/axios";

const perfilApi = {
  obtener,
  guardar,
};

export default perfilApi;

function obtener(id) {
  return axios
    .post(`${axios.defaults.baseUrl}/api/usuariocliente/${id}`)
    .then(resp => resp.data);
}

function guardar(obj) {
  return axios
    .put(`${axios.defaults.baseUrl}/api/usuariocliente/${obj._id}`, obj)
    .then(resp => resp.data);
}



// WEBPACK FOOTER //
// ./src/components/perfil/perfilApi.js